//
//
//
//
//
//
//
//
//
//
//

import ZonesCheckbox from './_zones_checkbox'
export default {
    components: {
        ZonesCheckbox
    },
    props: {
        zones: {
            type: [Object, null]
        }
    },
    data () {
        return {
            selected: [],
            selected_tx: []
        }
    },
    methods: {
        change (selected, selected_tx) {
            this.selected = selected
            this.selected_tx = selected_tx
        },
        reset () {
            this.selected = []
            this.selected_tx = []
        },
        confirm () {
            this.$emit('change', this.selected.join(','), this.selected_tx.join(','))
        }
    }
}
